// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"EditDevicePage_pageContainer__3IJA8","secondaryPageContainer":"EditDevicePage_secondaryPageContainer__puBp1"};